import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { Reveal, Overline } from "./Reveal";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="relative py-24 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <Reveal>
            <Overline>Loved by our community</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-white leading-[1.1]">
              Real routines. <span className="gold-text">Real people.</span>
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`testimonial-${i}`}
              className="glass rounded-2xl p-7 flex flex-col justify-between hover:border-gold/30 transition-colors duration-300"
            >
              <div>
                <Quote className="h-6 w-6 text-gold/50 mb-4" strokeWidth={1.5} />
                <p className="text-white/85 leading-relaxed text-[15px]">“{t.quote}”</p>
              </div>
              <div className="mt-6">
                <div className="flex gap-1 mb-2">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-3.5 w-3.5 text-gold" fill="currentColor" />
                  ))}
                </div>
                <p className="font-serif text-lg text-white">{t.name}</p>
                <p className="text-xs text-vmuted">{t.location}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <p className="mt-6 text-xs text-white/30">
          Testimonials reflect individual experiences and are illustrative.
        </p>
      </div>
    </section>
  );
};
